import React from "react";
import { Pie } from "@ant-design/plots";
import { CHART_PALETTE } from "../../chartPalette";

const data = [
  { type: "Cat 1", value: 27 },
  { type: "Cat 2", value: 25 },
  { type: "Cat 3", value: 18 },
  { type: "Cat 4", value: 15 },
  { type: "Cat 5", value: 10 },
  { type: "Other", value: 5 },
];

const total = data.reduce((sum, { value }) => sum + value, 0);

const DonutChart = () => {
  const config = {
    data,
    // One height for all four, so the cards line up in the grid.
    height: 320,
    angleField: "value",
    colorField: "type",
    // Same outer radius as the pie next to it, so the two circles read as a
    // pair rather than two different sizes.
    radius: 0.8,
    // innerRadius is a fraction of the outer radius, so shrinking the outer one
    // thinned the ring: 0.8 x (1 - 0.6) = 0.32 against the 0.4 it had before.
    // 0.45 puts the band slightly above its original thickness, at 0.44.
    innerRadius: 0.45,
    label: {
      text: "value",
      style: {
        fontWeight: "bold",
      },
    },
    legend: {
      color: {
        title: false,
        // Chart on the left, legend down the right side.
        position: "right",
        rowPadding: 5,
      },
    },
    annotations: [
      {
        type: "text",
        style: {
          // The sum of the slices — the one number a ring diagram is read for.
          text: `${total}`,
          x: "50%",
          y: "50%",
          textAlign: "center",
          // Without this the anchor is the first line's baseline, so the text
          // hangs below the centre of the ring instead of sitting in it.
          textBaseline: "middle",
          fontSize: 28,
          fontWeight: "bold",
        },
      },
    ],
    theme: {
      category10: CHART_PALETTE,
    },
  };

  return <Pie {...config} />;
};

export default DonutChart;
